import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";
import { fmtBRL } from "@/lib/format";

const getVenueHandle = (method, venue) => {
    if (method === "zelle") return venue?.zelle || "";
    if (method === "venmo") return venue?.venmo || "";
    return "";
};

const resultTitle = (status, position) => {
    if (status === "seat_available") return "You're in — take a seat!";
    if (status === "waitlisted") return `You're on the list (#${position})`;
    return `You're already #${position}`;
};

export default function ResultCard({ result, amount, method, venue, onReset }) {
    const showTransfer = amount && method !== "cash";
    return (
        <Card className="card-lux animate-fade-up" data-testid="ci-result">
            <CardContent className="p-8 text-center space-y-4">
                <CheckCircle weight="fill" size={56} className="text-gold mx-auto" />
                <h3 className="font-serif text-3xl">
                    {resultTitle(result.status, result.position)}
                </h3>
                <p className="text-muted-foreground max-w-md mx-auto" data-testid="checkin-result-msg">{result.message}</p>
                <div className="text-sm text-muted-foreground">
                    Confirmation for <span className="text-foreground">{result.player?.name}</span>{" "}
                    · <span className="font-mono-plex">{result.player?.phone}</span>
                </div>
                {showTransfer && (
                    <div className="rounded-md border border-gold/30 bg-secondary/40 p-4 max-w-md mx-auto text-left">
                        <div className="label-mini mb-1">
                            Send your buy-in of {fmtBRL(parseFloat(amount))} via {method.toUpperCase()} to
                        </div>
                        <div className="font-mono-plex text-lg text-gold">
                            {getVenueHandle(method, venue)}
                        </div>
                        <div className="text-xs text-muted-foreground mt-2">
                            Please transfer before arriving so your chips are ready.
                        </div>
                    </div>
                )}
                <Button data-testid="btn-checkin-new" onClick={onReset} className="btn-gold mt-2">
                    Check in another player
                </Button>
            </CardContent>
        </Card>
    );
}
